import axios from "axios";

const BASE_URL = 'https://youtube-v31.p.rapidapi.com'
const options = {

    url: BASE_URL,
    params: {

        maxResults: '50'
    },
    headers: {
        'X-RapidAPI-Key': '3085302423msh0b4a873a769f02cp1a6804jsn2c1d5d5165d8',
        'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
    }
};
export const fetchFromApi = async (url) => {
    const { data } = await axios.get(`${BASE_URL}/${url}`, options)

    return data
}
